/* eslint-disable react/jsx-no-undef */
import React from "react";
import Container from "@mui/material/Container";
import { Autocomplete, TextField, Checkbox } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";

import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from '../../components/layout/TopBanner';
import { setRegisterShop } from '../../features/register/RegisterShopSlice';
import { useDispatch } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import editAddressBanner from "../../assets/images/edit-address.png";
import CustomPopup from "../../components/popup/CustomPopup";
import { useLiff } from 'react-liff';
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { SearchDdlAddress } from "../../services/Dropdown";
import { UpdateMember } from "../../services/Shop";
import globalStyle from "../../assets/styles/constants";

export default function MemberInfoEditAddress() {

    const txt = {
        require: "กรุณากรอก",
        province: "จังหวัด",
        amphoe: "เขต/อำเภอ",
        tambol: "แขวง/ตำบล",
        zipCode: "รหัสไปรษณีย์",
    };

    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
    const [openEditedPopup, setOpenEditedPopup] = React.useState(false);

    const [addressList, setAddressList] = React.useState([]);
    const [delayId, setDelayId] = React.useState(null);
    const [subDistrict, setSubDistrict] = React.useState(null);
    const [amphoe, setAmphoe] = React.useState(null);
    const [province, setProvince] = React.useState(null);
    const [zipCode, setZipCode] = React.useState(null);

    const [openSubDistrict, setOpenSubDistrict] = React.useState(false);
    const [openAmphoe, setOpenAmphoe] = React.useState(false);
    const [openProvince, setOpenProvince] = React.useState(false);
    const [openZipCode, setOpenZipCode] = React.useState(false);

    const [deSubDistrict, setDeSubDistrict] = React.useState(null);
    const [deAmphoe, setDeAmphoe] = React.useState(null);
    const [deProvince, setDeProvince] = React.useState(null);
    const [deZipCode, setDeZipCode] = React.useState(null);

    const [openDeSubDistrict, setOpenDeSubDistrict] = React.useState(false);
    const [openDeAmphoe, setOpenDeAmphoe] = React.useState(false);
    const [openDeProvince, setOpenDeProvince] = React.useState(false);
    const [openDeZipCode, setOpenDeZipCode] = React.useState(false);


    const [isDelivery, setIsDelivery] = React.useState(state.payload.isDeliveryAddress);

    const { register, handleSubmit, getValues, setValue, control, watch } = useForm({
        defaultValues: {
            addressDetails: state.payload.addressDetails,
            subDistrict: state.payload.district,
            amphoe: state.payload.amphoe,
            province: state.payload.province,
            zipCode: state.payload.zipCode,
            isDeliveryAddress: state.payload.isDeliveryAddress,
            deAddressDetails: state.payload.deAddressDetails,
            deSubDistrict: state.payload.deDistrict,
            deAmphoe: state.payload.deAmphoe,
            deProvince: state.payload.deProvince,
            deZipCode: state.payload.deZipCode
        }
    });

    React.useEffect(() => {
        getSearchDefaultAddress();
    }, []);

    async function getSearchDefaultAddress() {
        try {
            if (getValues('amphoe')) {
                const search = `${getValues('subDistrict')} ${getValues('amphoe')} ${getValues('province')} ${getValues('zipCode')}`
                const { data } = await SearchDdlAddress({ params: { search } });
                if (+data["resultCode"] === 20000) {
                    const body = data.body || [];
                    setSubDistrict(body[0]);
                    setValue("subDistrict", body[0].subDistrict);
                    setValue("subDistrictId", body[0].subDistrictId);
                    setAmphoe(body[0]);
                    setValue("amphoe", body[0].amphoe);
                    setValue("amphoeId", body[0].amphoeId);
                    setProvince(body[0]);
                    setValue("province", body[0].province);
                    setValue("provinceId", body[0].provinceId);
                    setZipCode(body[0]);
                    setValue("zipCode", body[0].zipcode);
                } else {
                    setAddressList([]);
                }
            }
            if (getValues('deAmphoe')) {
                const search = `${getValues('deSubDistrict')} ${getValues('deAmphoe')} ${getValues('deProvince')} ${getValues('deZipCode')}`
                const { data } = await SearchDdlAddress({ params: { search } });
                if (+data["resultCode"] === 20000) {
                    const body = data.body || [];
                    setDeSubDistrict(body[0]);
                    setValue("deSubDistrict", body[0].deDistrict);
                    setValue("deSubDistrictId", body[0].deDistrictId);
                    setDeAmphoe(body[0]);
                    setValue("deAmphoe", body[0].deAmphoe);
                    setValue("deAmphoeId", body[0].deAmphoeId);
                    setDeProvince(body[0]);
                    setValue("deProvince", body[0].deProvince);
                    setValue("deProvinceId", body[0].deProvinceId);
                    setDeZipCode(body[0]);
                    setValue("deZipCode", body[0].dezipcode);
                } else {
                    setAddressList([]);
                }
            }
            if (getValues('isDeliveryAddress')) {
                fnSetDeliveryAddress(true)
            }
        } catch (error) {
            console.log("getSearchDdlAddress error", error);
        }
    }

    async function getSearchDdlAddress(search) {
        try {
            const { data } = await SearchDdlAddress({ params: { search } });
            if (+data["resultCode"] === 20000) {
                const body = data.body || [];
                setAddressList(body);
            } else {
                setAddressList([]);
            }
        } catch (error) {
            console.log("getSearchDdlAddress error", error);
        }
    }

    function fnRenderOption(props, option, { inputValue }) {
        const address1 = `${option.subDistrict}, ${option.amphoe}, ${option.zipcode}`;
        const address2 = `จังหวัด ${option.province}`;

        const matches1 = match(address1, inputValue, { insideWords: true });
        const parts1 = parse(address1, matches1);

        const matches2 = match(address2, inputValue, { insideWords: true });
        const parts2 = parse(address2, matches2);

        return (
            <li {...props} className="text-left pl-1 border-address-list">
                {/*display address*/}
                <div>
                    {parts1.map((part, index) => (
                        <span
                            key={index}
                            style={{
                                fontWeight: part.highlight ? 700 : 400,
                                color: part.highlight ? "#0A4197" : "#8F8F8F",
                            }}
                        >
                            {part.text}
                        </span>
                    ))}
                </div>
                {/*display province*/}
                <div>
                    {parts2.map((part, index) => (
                        <span
                            key={index}
                            style={{
                                fontWeight: part.highlight ? 700 : 400,
                                color: part.highlight ? "#0A4197" : "#8F8F8F",
                            }}
                        >
                            {part.text}
                        </span>
                    ))}
                </div>
            </li>
        );
    }

    function fnOnChangeAddress(e, value) {
        fnSetOpenAddress(txt.tambol, false);
        fnSetOpenAddress(txt.amphoe, false);
        fnSetOpenAddress(txt.province, false);
        fnSetOpenAddress(txt.zipCode, false);
        setSubDistrict(value);
        setValue("subDistrictId", value.subDistrictId);
        fnSetData("subDistrictId", value.subDistrictId);
        setAmphoe(value);
        setValue("amphoeId", value.amphoeId);
        fnSetData("amphoeId", value.amphoeId);
        setProvince(value);
        setValue("provinceId", value.provinceId);
        fnSetData("provinceId", value.provinceId);
        setZipCode(value);
        setValue("zipCode", value.zipcode);
        fnSetData("zipCode", value.zipcode);

    }

    async function onInputChangeAddress(e, type) {
        fnSetOpenAddress(type, false);
        const value = e.target.value;
        clearTimeout(delayId);
        const timeoutId = setTimeout(async () => {
            if (value) {
                await getSearchDdlAddress(value);
                fnSetOpenAddress(type, true);
            } else {
                setAddressList([]);
            }
        }, 500);
        setDelayId(timeoutId);
    }

    function fnSetOpenAddress(type, open) {
        if (type === txt.tambol) {
            setOpenSubDistrict(open);
        } else if (type === txt.amphoe) {
            setOpenAmphoe(open);
        } else if (type === txt.province) {
            setOpenProvince(open);
        } else if (type === txt.zipCode) {
            setOpenZipCode(open);
        }
    }

    function fnOnChangeDeAddress(e, value) {
        fnSetOpenDeAddress(txt.tambol, false);
        fnSetOpenDeAddress(txt.amphoe, false);
        fnSetOpenDeAddress(txt.province, false);
        fnSetOpenDeAddress(txt.zipCode, false);
        setDeSubDistrict(value);
        setValue("deSubDistrictId", value.subDistrictId);
        fnSetData("deSubDistrictId", value.subDistrictId);
        setDeAmphoe(value);
        setValue("deAmphoeId", value.amphoeId);
        fnSetData("deAmphoeId", value.amphoeId);
        setDeProvince(value);
        setValue("deProvinceId", value.provinceId);
        fnSetData("deProvinceId", value.provinceId);
        setDeZipCode(value);
        setValue("deZipCode", value.zipcode);
        fnSetData("deZipCode", value.zipcode);
    }

    async function onInputChangeDeAddress(e, type) {
        fnSetOpenDeAddress(type, false);
        const value = e.target.value;
        clearTimeout(delayId);
        const timeoutId = setTimeout(async () => {
            if (value) {
                await getSearchDdlAddress(value);
                fnSetOpenDeAddress(type, true);
            } else {
                setAddressList([]);
            }
        }, 500);
        setDelayId(timeoutId);
    }

    function fnSetOpenDeAddress(type, open) {
        if (type === txt.tambol) {
            setOpenDeSubDistrict(open);
        } else if (type === txt.amphoe) {
            setOpenDeAmphoe(open);
        } else if (type === txt.province) {
            setOpenDeProvince(open);
        } else if (type === txt.zipCode) {
            setOpenDeZipCode(open);
        }
    }

    function fnSetDeliveryAddress(checked) {
        if (checked) {
            setValue("deAddressDetails", getValues('address'));
            setDeSubDistrict(subDistrict);
            setValue("deSubDistrictId", getValues('subDistrictId'));
            setDeAmphoe(amphoe);
            setValue("deAmphoeId", getValues('amphoeId'));
            setDeProvince(province);
            setValue("deProvinceId", getValues('provinceId'));
            setDeZipCode(zipCode);
            setValue("deZipCode", getValues('zipCode'));
        } else {
            setValue("deAddressDetails", '');
            setDeSubDistrict(null);
            setValue("deSubDistrictId", '');
            setDeAmphoe(null);
            setValue("deAmphoeId", '');
            setDeProvince(null);
            setValue("deProvinceId", '');
            setDeZipCode(null);
            setValue("deZipCode", '');
        }
    }

    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setRegisterShop(tmpObj));
    }

    React.useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name && type) {
                fnSetData(name, value[name]);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const onSubmit = (data) => {
        setOpenEditedPopup(true);
    };

    async function postUpdateMember() {
        try {
            let payload = {
                lineId: lineId,
                address: {
                    id: state.payload.memberId,
                    addressDetails: getValues('addressDetails'),
                    amphoe: amphoe.amphoeId,
                    district: subDistrict.subDistrictId,
                    province: province.provinceId,
                    zipCode: getValues('zipCode'),
                    isDeliveryAddress: getValues('isDeliveryAddress'),
                    deAddressDetails: getValues('isDeliveryAddress') ? getValues('addressDetails') : getValues('deAddressDetails'),
                    deAmphoe: getValues('isDeliveryAddress') ? amphoe.amphoeId : (deAmphoe ? deAmphoe.amphoeId : null),
                    deDistrict: getValues('isDeliveryAddress') ? subDistrict.subDistrictId : (deSubDistrict ? deSubDistrict.subDistrictId : null),
                    deProvince: getValues('isDeliveryAddress') ? province.provinceId : (deProvince ? deProvince.provinceId : null),
                    deZipCode: getValues('isDeliveryAddress') ? getValues('zipCode') : getValues('deZipCode'),
                    fullAddress: amphoe ? `${getValues('addressDetails')} ${amphoe.amphoe} ${subDistrict.subDistrict} ${province.province} ${getValues('zipCode')}` : getValues('addressDetails'),
                    fullDeAddress: getValues('isDeliveryAddress') ? (amphoe ? `${getValues('addressDetails')} ${amphoe.amphoe} ${subDistrict.subDistrict} ${province.province} ${getValues('zipCode')}` : getValues('address')) : (deAmphoe ? `${getValues('deAddressDetails')} ${deAmphoe ? deAmphoe.amphoe : ''} ${deSubDistrict ? deSubDistrict.subDistrict : ''} ${deProvince ? deProvince.province : ''} ${getValues('deZipCode')}` : getValues('deAddressDetails')),
                }
            }
            Object.keys(payload).forEach(key => {
                if (payload[key] === null) {
                    delete payload[key];
                }
            });
            const { data } = await UpdateMember({ data: payload });
            if (+data["resultCode"] === 20000) {
                navigate("/member-info");
            } else {
                console.log('Error' + data["resultCode"])
            }
        } catch (error) {
            console.log("postCreateMember error", error);
        }
    }



    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
                <CustomPopup
                    title={"แก้ไขข้อมูลที่อยู่"}
                    desc={"คุณได้แก้ไขข้อมูลที่อยู่ของคุณ \n หากมั่นใจแล้ว กรุณากด ยืนยัน เพื่อดำเนินการต่อ"}
                    actionText={'ยืนยัน'}
                    actionFunction={() => {
                        postUpdateMember();
                        setOpenEditedPopup(false);
                    }}
                    cancelText={"ยกเลิก"}
                    cancelFunction={() => {
                        setOpenEditedPopup(false);
                    }}
                    open={openEditedPopup}
                    onClose={() => {
                        setOpenEditedPopup(false);
                    }}
                />

                <CustomPopup
                    title={"ยกเลิกแก้ไขข้อมูลที่อยู่"}
                    desc={
                        "การแก้ไขของคุณยังไม่ถูกบันทึก \n หากต้องการยกเลิก กรุณากด ยืนยัน เพื่อดำเนินการต่อ"
                    }
                    cancelFunction={() => {
                        setOpenCancelPopup(false);
                    }}
                    cancelText={"ยกเลิก"}
                    actionText={'ยืนยัน'}
                    actionFunction={() => {
                        setOpenCancelPopup(false);
                        navigate(-1);
                    }}
                    open={openCancelPopup}
                    onClose={() => {
                        setOpenCancelPopup(false);
                    }}
                />
                <TopLogo />
                <TopBanner type="memberInfo" />
                <Container maxWidth="xl">
                    <img src={editAddressBanner} alt="logo" style={{ width: "100%", marginTop: "-50px" }} />
                    <div className="bg-white px-3">
                        <div style={{ padding: "0 10px" }}>
                            <div className="flex gap-[10px] justify-start">
                                <div className="primary-color title-size">ที่อยู่ </div>
                                <div style={{ marginTop: "6px" }}>
                                    <p className="sub-title-size">Address</p>
                                    <div className="blue-line" ></div>
                                </div>
                            </div>

                            <div className="mt-2">
                                <InputLabel className="text-header1 text-left" htmlFor="txtEmail">ที่อยู่</InputLabel>
                                <TextField
                                    placeholder="ที่อยู่ของคุณ"
                                    id="txtEmail"
                                    fullWidth
                                    {...register("addressDetails")}
                                />
                            </div>

                            <div className="grid grid-cols-2 gap-2 mt-2">
                                <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlSubDistrict">แขวง / ตำบล</InputLabel>
                                <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlDistrict">เขต / อำเภอ</InputLabel>
                            </div>
                            <div className="grid grid-cols-2 gap-5">
                                <Controller
                                    name="subDistrictId"
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            freeSolo
                                            disableClearable
                                            onChange={fnOnChangeAddress}
                                            options={addressList}
                                            open={openSubDistrict}
                                            onClose={() => fnSetOpenAddress(txt.tambol, false)}
                                            getOptionLabel={(option) => option.subDistrict}
                                            value={subDistrict}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    placeholder="พิมพ์แขวง/ตำบล"
                                                    onInput={(e) => onInputChangeAddress(e, txt.tambol)}
                                                />
                                            )}
                                            renderOption={fnRenderOption}
                                        />
                                    )}
                                />

                                <Controller
                                    name="amphoeId"
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            freeSolo
                                            disableClearable
                                            onChange={fnOnChangeAddress}
                                            options={addressList}
                                            open={openAmphoe}
                                            onClose={() => fnSetOpenAddress(txt.amphoe, false)}
                                            getOptionLabel={(option) => option.amphoe}
                                            value={amphoe}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    placeholder="พิมพ์เขต/อำเภอ"
                                                    onInput={(e) => onInputChangeAddress(e, txt.amphoe)}
                                                />
                                            )}
                                            renderOption={fnRenderOption}
                                        />
                                    )}
                                />

                            </div>

                            <div className="">
                                <InputLabel className="text-header1 text-left" htmlFor="ddlProvince">จังหวัด</InputLabel>
                                <Controller
                                    name="provinceId"
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            freeSolo
                                            disableClearable
                                            onChange={fnOnChangeAddress}
                                            options={addressList}
                                            open={openProvince}
                                            onClose={() => fnSetOpenAddress(txt.province, false)}
                                            getOptionLabel={(option) => option.province}
                                            value={province}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    placeholder="พิมพ์จังหวัด"
                                                    onInput={(e) => onInputChangeAddress(e, txt.province)}
                                                />
                                            )}
                                            renderOption={fnRenderOption}
                                        />
                                    )}
                                />
                            </div>

                            <div className="mt-2">
                                <InputLabel className="text-header1 text-left" htmlFor="txtZipCode">รหัสไปรษณีย์</InputLabel>
                                <Controller
                                    name="zipCode"
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            freeSolo
                                            disableClearable
                                            onChange={fnOnChangeAddress}
                                            options={addressList}
                                            open={openZipCode}
                                            onClose={() => fnSetOpenAddress(txt.zipCode, false)}
                                            getOptionLabel={(option) => option.zipcode}
                                            value={zipCode}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    placeholder="พิมพ์รหัสไปรษณีย์"
                                                    onInput={(e) => onInputChangeAddress(e, txt.zipCode)}
                                                />
                                            )}
                                            renderOption={fnRenderOption}
                                        />
                                    )}
                                />
                            </div>

                            <div className="flex gap-[5px] justify-start mt-2">
                                <Checkbox
                                    checked={isDelivery}
                                    onChange={(event) => {
                                        setValue('isDeliveryAddress', !getValues('isDeliveryAddress'))
                                        setIsDelivery(!isDelivery)
                                        fnSetDeliveryAddress(event.target.checked)
                                    }}
                                    inputProps={{ "aria-label": "controlled" }}
                                    sx={globalStyle.checkboxStyle}
                                />
                                <p style={{ fontSize: "20px" }} className="text-left mt-[4px]">ใช้ที่อยู่นี้เป็นที่อยู่จัดส่ง</p>
                            </div>

                            {!getValues('isDeliveryAddress') && (
                                <div className="mb-[10px]">
                                    <div className="">
                                        <InputLabel className="text-header1 text-left" htmlFor="txtAddress">ที่อยู่จัดส่ง</InputLabel>
                                        <TextField
                                            id="txtAddress"
                                            fullWidth
                                            placeholder="ที่อยู่ของคุณ"
                                            {...register("deAddressDetails")}
                                        />
                                    </div>
                                    <div className="grid grid-cols-2 gap-2 mt-2">
                                        <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlSubDistrict">แขวง / ตำบล</InputLabel>
                                        <InputLabel required={true} className="text-header1 text-left" htmlFor="ddlDistrict">เขต / อำเภอ</InputLabel>
                                    </div>
                                    <div className="grid grid-cols-2 gap-5">
                                        <Controller
                                            name="deSubDistrictId"
                                            control={control}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    {...field}
                                                    freeSolo
                                                    disableClearable
                                                    onChange={fnOnChangeDeAddress}
                                                    options={addressList}
                                                    open={openDeSubDistrict}
                                                    onClose={() => fnSetOpenDeAddress(txt.tambol, false)}
                                                    getOptionLabel={(option) => option.subDistrict}
                                                    value={deSubDistrict}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            placeholder="พิมพ์แขวง/ตำบล"
                                                            onInput={(e) => onInputChangeDeAddress(e, txt.tambol)}
                                                        />
                                                    )}
                                                    renderOption={fnRenderOption}
                                                />
                                            )}
                                        />

                                        <Controller
                                            name="deAmphoeId"
                                            control={control}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    {...field}
                                                    freeSolo
                                                    disableClearable
                                                    onChange={fnOnChangeDeAddress}
                                                    options={addressList}
                                                    open={openDeAmphoe}
                                                    onClose={() => fnSetOpenDeAddress(txt.amphoe, false)}
                                                    getOptionLabel={(option) => option.amphoe}
                                                    value={deAmphoe}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            placeholder="พิมพ์เขต/อำเภอ"
                                                            onInput={(e) => onInputChangeDeAddress(e, txt.amphoe)}
                                                        />
                                                    )}
                                                    renderOption={fnRenderOption}
                                                />
                                            )}
                                        />

                                    </div>

                                    <div className="">
                                        <InputLabel className="text-header1 text-left" htmlFor="ddlProvince">จังหวัด</InputLabel>
                                        <Controller
                                            name="deProvinceId"
                                            control={control}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    {...field}
                                                    freeSolo
                                                    disableClearable
                                                    onChange={fnOnChangeDeAddress}
                                                    options={addressList}
                                                    open={openDeProvince}
                                                    onClose={() => fnSetOpenDeAddress(txt.province, false)}
                                                    getOptionLabel={(option) => option.province}
                                                    value={deProvince}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            placeholder="พิมพ์จังหวัด"
                                                            onInput={(e) => onInputChangeDeAddress(e, txt.province)}
                                                        />
                                                    )}
                                                    renderOption={fnRenderOption}
                                                />
                                            )}
                                        />
                                    </div>

                                    <div className="mt-2">
                                        <InputLabel className="text-header1 text-left" htmlFor="txtZipCode">รหัสไปรษณีย์</InputLabel>
                                        <Controller
                                            name="deZipCode"
                                            control={control}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    {...field}
                                                    freeSolo
                                                    disableClearable
                                                    onChange={fnOnChangeDeAddress}
                                                    options={addressList}
                                                    open={openDeZipCode}
                                                    onClose={() => fnSetOpenDeAddress(txt.zipCode, false)}
                                                    getOptionLabel={(option) => option.zipcode}
                                                    value={deZipCode}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            placeholder="พิมพ์รหัสไปรษณีย์"
                                                            onInput={(e) => onInputChangeDeAddress(e, txt.zipCode)}
                                                        />
                                                    )}
                                                    renderOption={fnRenderOption}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            )}

                            <br></br>
                            <br></br>
                        </div>
                    </div>
                </Container>
                <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
                    <Stack
                        spacing={2}
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => setOpenCancelPopup(true)}>
                            ยกเลิก
                        </SecondaryButton>
                        <PrimaryButton variant="contained" className="w-[40%]" onClick={() => setOpenEditedPopup(true)}>
                            บันทึก
                        </PrimaryButton>
                    </Stack>
                </div>
            </form>
        </>
    );
}
